import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component,user, ...rest }) => (
    <Route {...rest} render={props => {
        const currentUser = user.userToken !== null && user.userToken !== undefined && user.userToken !== "";
        
        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        // authorised so return component
        return <Component {...props} />
    }} />
)